import { Map, OrderedMap, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import ReviewCyclesConstants from 'Shared/constants/ReviewCycles.constants';

const initialState = Map({
  [ReviewCyclesConstants.State.REVIEWS_CYCLES_BY_SLUG]: OrderedMap(),
});

export const ReviewCyclesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReviewCyclesConstants.Actions.FETCH_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.FETCH_REVIEW_CYCLES_SUCCESS:
    case ReviewCyclesConstants.Actions.CREATE_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.UPDATE_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.LAUNCH_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.LAUNCH_SCHEDULED_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.CLOSE_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.UNSCHEDULE_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.DELETE_REVIEW_SUCCESS:
    case ReviewCyclesConstants.Actions.CREATE_REVIEWS_ON_REVIEW_CYCLE_SUCCESS:
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn([ReviewCyclesConstants.State.REVIEWS_CYCLES_BY_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          // @ts-ignore
          Object.values(action.payload.reviewCycle).map(item => [item.id, Map(fromJS(item.attributes))])
        )
      );

    case ReviewCyclesConstants.Actions.CANCEL_REVIEW_CYCLE_SUCCESS:
      return state.deleteIn([ReviewCyclesConstants.State.REVIEWS_CYCLES_BY_SLUG, action.payload.slug]);

    default:
      return state;
  }
};
